export default __webpack_public_path__ + "images/1ea03127d3e281cd0484597550791516-las_vegas_mobile.webp";